module.exports = __webpack_public_path__ + "build/img/context-ads.02dc3b25.svg";